import _ from 'underscore';

function columnsListToSet(columnList) {
  return _.reduce(columnList, (memo, col) => {
    memo[col] = true; // eslint-disable-line no-param-reassign

    return memo;
  }, {});
}

// If IsViewThroughConversionEnabled is not enabled, then
// ViewThroughConversions should not be selectable.
export function isConversionsColumnAllowed({
  name,
  IsViewThroughConversionEnabled,
}) {
  if (IsViewThroughConversionEnabled) {
    return true;
  }

  return name !== 'ViewThroughConversions' && name !== 'ViewThroughConversionsCredit';
}

export function columnConfigToColumnChooserConfig(columnConfig, lockedColumns) {
  const lockedColumnsSet = columnsListToSet(lockedColumns);

  return _.map(columnConfig, ({ name, title }) => ({
    key: name,
    name: title,
    selectOption: lockedColumnsSet[name] ? 'locked' : 'optional',
  }));
}
